import React from "react";
import PropTypes from "prop-types";
import { Alert, Button, CircularProgress } from "@mui/material";
import { cycleDate, entryToISO } from "../../model/cycleModel";
import CycleDialog, { CycleFields } from "../CycleDialog";

export default function ConfirmacionCreacionDialog({
  open,
  onClose,
  onConfirm,
  formData,
  cicloCreado,
  loading,
}) {
  return (
    <CycleDialog
      open={open}
      onClose={onClose}
      busy={loading}
      compact
      title={cicloCreado ? "Operación aceptada" : "Confirmar creación del ciclo"}
      subtitle={
        cicloCreado
          ? "Resultado confirmado por el servicio"
          : "Revise el ingreso antes de continuar"
      }
      actions={
        <>
          {!cicloCreado && (
            <Button variant="outlined" onClick={onClose} disabled={loading}>
              Volver
            </Button>
          )}
          <Button
            onClick={onConfirm}
            variant="contained"
            disabled={loading}
            sx={{ bgcolor: "#185a75", color: "#fff", "&:hover": { bgcolor: "#103f54" } }}
          >
            {loading && <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />}
            {cicloCreado ? "Cerrar" : loading ? "Enviando..." : "Confirmar creación"}
          </Button>
        </>
      }
    >
      <Alert severity={cicloCreado ? "success" : "info"} sx={{ borderRadius: 2 }}>
        {cicloCreado
          ? "El servicio confirmó la operación."
          : "Se enviará una solicitud con los siguientes datos."}
      </Alert>
      <CycleFields
        title="RESUMEN DEL INGRESO"
        fields={[
          ["Comercio", formData?.commerceName],
          ["Código del comercio", formData?.commerceCode],
          ["Placa", formData?.plate],
          [
            "Ingreso · Bogotá",
            formData?.date && formData?.time
              ? cycleDate(entryToISO(formData.date, formData.time))
              : "",
          ],
        ]}
      />
    </CycleDialog>
  );
}
ConfirmacionCreacionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  formData: PropTypes.object,
  cicloCreado: PropTypes.bool,
  loading: PropTypes.bool,
};
ConfirmacionCreacionDialog.defaultProps = { formData: null, cicloCreado: false, loading: false };
